export default __webpack_public_path__ + "static/media/bot8.00d97ca9.png";